import { http } from "./http.js";

export interface InstallationMetadata {
  install_id: string;
  feishu_app_token: string;
  feishu_table_id: string;
  feishu_tenant_key: string | null;
  display_name: string;
  enabled_platforms: string[];
  status: "active" | "paused" | "disabled";
  has_pat: boolean;
  has_robot_webhook: boolean;
  created_by_user_id: string | null;
}

export interface CreateInstallationInput {
  app_token: string;
  table_id: string;
  display_name: string;
  pat: string;
  robot_webhook?: string;
  enabled_platforms?: string[];
  tenant_key?: string;
}

export async function getMe(): Promise<InstallationMetadata> {
  const res = await http.get<{ installation: InstallationMetadata }>("/installations/me");
  return res.data.installation;
}

export async function createInstallation(
  input: CreateInstallationInput,
): Promise<{ installation: InstallationMetadata; session_token: string }> {
  const res = await http.post<{ installation: InstallationMetadata; session_token: string }>(
    "/installations",
    input,
  );
  return res.data;
}

export interface UpdateInstallationInput {
  display_name?: string;
  table_id?: string;
  pat?: string;
  robot_webhook?: string | null;
  enabled_platforms?: string[];
  status?: "active" | "paused" | "disabled";
}

export async function updateMe(input: UpdateInstallationInput): Promise<InstallationMetadata> {
  const res = await http.patch<{ installation: InstallationMetadata }>(
    "/installations/me",
    input,
  );
  return res.data.installation;
}

export async function testPat(input: {
  pat: string;
  table_id: string;
}): Promise<{ ok: boolean; total?: number; reason?: string }> {
  const res = await http.post<{ ok: boolean; total?: number; reason?: string }>(
    "/installations/me/test-pat",
    input,
  );
  return res.data;
}

// 首装阶段（还没 session）：用 setup_token 调后端测 PAT，避开浏览器跨域 base-api.feishu.cn 的 CORS 限制
export async function testPatSetup(input: {
  pat: string;
  app_token: string;
  table_id: string;
}): Promise<{ ok: boolean; total?: number; reason?: string }> {
  const res = await http.post<{ ok: boolean; total?: number; reason?: string }>(
    "/installations/test-pat-setup",
    input,
  );
  return res.data;
}

export async function testRobot(): Promise<{ ok: boolean; message_id?: string; reason?: string }> {
  const res = await http.post<{ ok: boolean; message_id?: string; reason?: string }>(
    "/installations/me/test-robot",
  );
  return res.data;
}
